import { Typography } from '@mui/material';

import { Service } from 'common/src/types/enums/Service.enum';

import DataTable from 'portal/src/components/common/DataTable';
import { numberFormatter } from 'portal/src/utils/numberFormatter';

import { MonthlyFacilityCost } from '../../common';

export const ViewMonthDetails = ({
  fiscalMonthSelected,
  monthlyFacilityCosts,
  addFacilityBtn,
  onEditClick,
  onDeleteClick,
}: {
  fiscalMonthSelected?: number;
  monthlyFacilityCosts?: MonthlyFacilityCost[];
  addFacilityBtn: JSX.Element;
  onEditClick: (facilityId: string) => void;
  onDeleteClick: (facilityId: string) => void;
}) => {
  return (
    <DataTable
      actionsConfig={{
        inRowEditConfig: {
          btnConfig: (row) => ({
            useEditIcon: true,
            overrideEditBtn: () => onEditClick(row.id),
            onDeleteClick: () => onDeleteClick(row.id),
          }),
        },
      }}
      checkboxSelection={false}
      columns={[
        {
          field: 'facilityName',
          headerName: 'Facility Name',
          flex: 1,
        },
        {
          field: 'services',
          headerName: 'Service Type',
          valueFormatter: (value) =>
            Array.isArray(value) ? (value as Service[]).join(', ') : value,
          flex: 1,
        },
        {
          field: 'totalCosts',
          headerName: 'Cost',
          valueFormatter: (value) => numberFormatter(Number(value)),
          flex: 1,
        },
      ]}
      hideFooter
      isRowNavigation={false}
      rows={fiscalMonthSelected ? monthlyFacilityCosts : []}
      toolbarSlotProps={{
        children: addFacilityBtn,
        showFilters: false,
      }}
      noDataDisplay={
        <Typography variant="subtitle1" textAlign="center" margin={15}>
          Select fiscal month to show details.
        </Typography>
      }
    />
  );
};
